import { render, staticRenderFns } from "./InsuranceHistory.vue?vue&type=template&id=0d52f0c7&scoped=true"
import script from "./InsuranceHistory.vue?vue&type=script&lang=js"
export * from "./InsuranceHistory.vue?vue&type=script&lang=js"
import style0 from "./InsuranceHistory.vue?vue&type=style&index=0&id=0d52f0c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52f0c7",
  null
  
)

export default component.exports